import { NotificationCard } from '@components';
import { Button, Container, Typography } from '@design-system';
import React from 'react';
import { MdDoneAll } from 'react-icons/md';
import './NotificationsPage.scss';
import { useNotificationsPageVM } from './useNotificationsPageVM';

export const NotificationsPage: React.FC = () => {
    const {
        notifications,
        isLoading,
        isError,
        hasUnseen,
        isMarkingAll,
        handleNotificationClick,
        handleMarkAllAsSeen
    } = useNotificationsPageVM();

    return (
        <Container className="notifications-page" padding="medium">
            {!isLoading && !isError && notifications.length > 0 && (
                <div className="notifications-toolbar">
                    <Button
                        color="green"
                        variant="secondary"
                        size="small"
                        icon={<MdDoneAll />}
                        onClick={handleMarkAllAsSeen}
                        disabled={!hasUnseen || isMarkingAll}
                    >
                        Tout marquer comme lu
                    </Button>
                </div>
            )}
            <div className="notifications-list">
                {isLoading ? (
                    <Typography intrinsic="p">Chargement des notifications...</Typography>
                ) : isError ? (
                    <Container center padding="large">
                        <Typography intrinsic="p" variant="secondary" color="grey">
                            Erreur lors du chargement des notifications
                        </Typography>
                    </Container>
                ) : notifications.length === 0 ? (
                    <Container center padding="large">
                        <Typography intrinsic="p" variant="secondary" color="grey">
                            Aucune notification à afficher
                        </Typography>
                    </Container>
                ) : (
                    notifications.map((notification) => (
                        <NotificationCard
                            key={notification.id}
                            notification={notification}
                            onClick={() => handleNotificationClick(notification)}
                        />
                    ))
                )}
            </div>
        </Container>
    );
};
